export const SELECT_ORG_TYPE = {
    CHANGEORG: "changeOrg", // 切换企业
    BUYORG: "buyOrg", // 购买企业会员
};

export const HOME_PAGE_TYPE = {
    CLOTHING: "clothing", // 服装版
    MERCHANDISE: "merchandise", // 商品版
    IMAGE_SERVICE: "image_service", // AI商拍服务
    MODEL_VIDEO: "model_video", // 模特视频
    BATCH_IMAGES: "batch_images", // 企业版
};

export const TYPETITLEMAP = {
    model: "换模特",
    modelChangeBkg: "换背景",
    clothes: "AI试衣",
    shoesTryon: "鞋子上脚",
    tryonVideo: "动作模仿",
    commodity: "商品换背",
    commodityRecolor: "商品换色",
    clothRecolor: "服饰换色",
    aiEdit: "AI编辑",
    aiImageExtraction: "智能抠图",
    removeInpaint: "魔法擦除",
    aibeauty: "智能补光",
    imageFiner: "AI超清",
    aiSmartBeauty: "智能美化",
    imageResize: "高清改尺寸",
    handFix: "手部修复",
    dressform: "人台图",
    poseFantasy: "姿势裂变",
    glassesTryon: "眼镜试戴",
    jewelryTryon: "项链试戴",
    simTryon: "同版型试衣",
    image2Video: "图生视频",
    fusionWear: "搭配上身",
    creativeImageGen: "创意生图",
    grassPlant: "种草图",
    smartDetailPage: "服装详情页",
    watermarkRemove: "去水印",
};

export const IMAGE_TYPE = {
    MODEL: "model", // 换模特
    BACKGROUND: "modelChangeBkg", // 换背景
    DRESSFORM: "dressform", // 人台图
    COMMODITY: "commodity", // 商品图
    COMMODITY_VIDEO: "commodityVideo", // 商品视频
    CLOTHES: "clothes", // AI试衣
    MODEL_VIDEO: "tryonVideo", // 动作模仿
    IMAGE_TO_VIDEO: "image2Video", // 图生视频
    SHOES: "shoesTryon", // 鞋子上脚
    COMMODITYRECOLOR: "commodityRecolor", // 商品换色
    CLOTH_RECOLOR: "clothRecolor", // 服饰复色
    AIEDIT: "aiEdit", // AI编辑
    AI_IMAGE_EXTRACTION: "aiImageExtraction",
    REMOVE_INPAINT: "removeInpaint",
    AI_BEAUTY: "aibeauty",
    IMAGE_FINER: "imageFiner",
    AI_SMART_BEAUTY: "aiSmartBeauty",
    IMAGE_RESIZE: "imageResize",
    HAND_FIX: "handFix",
    POSE_TRYON: "poseFantasy", // 姿势裂变
    GLASSES_TRYON: "glassesTryon", // 眼镜试戴
    NECKLACE_TRYON: "jewelryTryon", // 项链试戴
    SIM_TRYON: "simTryon", // 同版型试衣
    FUSION_WEAR: "fusionWear", // 搭配上身
    CREATIVE_IMAGE_GEN: "creativeImageGen", // 创意生图
    GRASS_PLANT: "grassPlant", // 种草图
    SMART_DETAILA_PAGE: "smartDetailPage", // 服装详情页
    WATERMARK_REMOVE: "watermarkRemove", // 去水印
};

export const SERVICE_OPTIONS = [
    {
        label: "AI换模特",
        value: "model",
        algoValue: "headSkinFantasy",
        interfaceValue: 1,
        version: "2.1.20250522",
    },
    {
        label: "AI试衣",
        value: "clothes",
        algoValue: "tryon",
        interfaceValue: 0,
        version: "2.4.20250724",
    },
    {
        label: "鞋子上脚",
        value: "shoesTryon",
        algoValue: "shoesTryon",
        interfaceValue: 2,
        version: "2.4.20250724",
    },
    {
        label: "服装复色",
        value: "clothRecolor",
        algoValue: "clothRecolor",
        interfaceValue: 3,
        version: "2.3.20250703",
    },
];

export const PRODUCT_OPTIONS = [
    {
        label: "AI试衣",
        value: "clothes",
    },
    {
        label: "换模特",
        value: "model",
    },
    {
        label: "换背景",
        value: "background",
    },
];

export const ALGO_TYPE = {
    MODEL: "modelInpaint", // 真人图
    DRESSFORM: "dressformInpaint", // 人台图
    COMMODITY: "commodityInpaint", // 商品图
    COMMODITY_REMOVE: "removeInpaint", // 商品拍同款
    COMMODITY_VIDEO: "commodityVideo", // 商品视频
    CLOTHES: "tryonInpaint", // AI试衣
    MODEL_VIDEO: "tryonVideo", // 衣服视频
};

// AI编辑枚举值
export const AIEDIT_SOURCE = {
    AI_LIGHT: "aibeauty", // 补光
    AI_BEAUTY: "aiSmartBeauty", // 美颜
    AI_QUALITY: "superResolution", // 超分
    AI_REMOVE: "removeInpaint", // 擦除
    AI_SHAPE_SHIFT: "aidraggan", // 变形
    AI_IMAGE_EXTRACTION: "aiImageExtraction", // 智能抠图
    COMMODITYRECOLOR: "commodityRecolor", // 商品换色
    CLOTH_RECOLOR: "clothRecolor", // 服饰换色
};

// 大客户专属功能枚举值
export const PRIVATE_ABILITIES = {
    TRYON_DIY_POSE: "TRYON_DIY_POSE",
    MODEL_KEEP_POSE: "MODEL_KEEP_POSE",
    TRYON_KEEP_POSE: "TRYON_KEEP_POSE",
    TRYON_KEEP_BKG: "TRYON_KEEP_BKG",
    VIDEO_TRYON_DIY_KEY: "VIDEO_TRYON_DIY_KEY",
    VIDEO_TRYON_SUPPORT_BACK: "VIDEO_TRYON_SUPPORT_BACK", // 视频背身图是否支持
    MODEL_SAME_STYLE: "MODEL_SAME_STYLE", // 真人拍同款
};

// 特征：表情
export const FACE_OPTIONS = [
    { text: "默认", value: "default" },
    { text: "微笑", value: "(light smile:1.3)" },
];

// 特征：表情
export const HAIR_OPTIONS = [
    { text: "默认", value: "default" },
    { text: "短发", value: "(Bob haircut)" },
    { text: "长发", value: "(long hair:1.3)" },
    { text: "直发", value: "(straigth hair:1.3)" },
    { text: "卷发", value: "(curly hair:1.3)" },
    { text: "马尾", value: "(twintails:1.3)" },
    { text: "丸子头", value: "(double bun:1.3)" },
    { text: "齐刘海", value: "(blunt bangs:1.3)" },
];

// 图片上传来源
export const UPLOAD_SOURCE = {
    MODEL: "model", // 真人图
    POSE_TRYON: "poseFantasy", // 姿势裂变
    GLASSES_TRYON: "glassesTryon", // 眼镜试戴
    NECKLACE_TRYON: "jewelryTryon", // 项链试戴
    SIM_TRYON: "simTryon", // 同版型试衣
    DRESSFORM: "dressform", // 人台图
    SHOES: "shoesTryon", // 人台图
    COMMODITY: "commodity", // 商品图
    CLOTH_TOP: "cloth_top", // 衣服上装
    CLOTH_BOTTOM: "cloth_bottom", // 衣服下装
    CLOTH_DRESS: "cloth_dress", // 衣服连体装
    TRYON_VIDEO: "tryon_video", // 模特视频输入
    AIEDIT_MODEL: "ai_edit_model", // AI编辑-服装图
    AIEDIT_COMMODITY: "ai_edit_commodity", // AI编辑-商品图
    EXTRACTION: "extraction", // 抠图输入
    SERVICE: "service", // 服务助手
    BATCHIMAGES: "batchimages", // 批量处理
    GRASS_PLANT: "grassPlant", // 种草图
    WATERMARK_REMOVE: "watermarkRemove", // 去水印
};

// 算法类型
export const TOPIC = {
    AIMODEL_INPAINT: "aimodel_inpaint",
    AIBKGMODEL_INPAINT: "aibkgmodel_inpaint",
    REPLACE_INPAINT: "airemove_inpaint",
};

export const INPAINT_TYPE = {
    AIHANDREFINE_HANDLE: "aihandrefine_handle", // 手部修复
    AISAMESTYLETRYON_HANDLE: "aisamestyletryon_handle", // 同版型替换
    AILIVEPHOTO_HANDLE: "ailivephoto_handle", // 表情迁移及多角度人脸
    AIREMOVE_INPAINT: "airemove_inpaint", // 发型修复
    AIBEAUTY_HANDLE: "aibeauty_handle", // 美颜
    AIMOTEFLUX_HANDLE: "aimoteflux_handle", // 重绘
    AIGOODSRECOLOR_HANDLE: "aigoodsrecolor_handle", // 商品换色
};

export const RESIZE_IMG_CANVASNAME = {
    LEFT_CANVAS_NAME: "leftCanvasName",
    RIGHT_CANVAS_NAME: "rightCanvasName",
    SCROLL_CANVAS: "scrollCanvas",
};

// 试衣衣服平铺图类型
export const INPUT_IMAGE_TYPE = {
    SINGLE: "single", // 单件服装
    MULTI: "multi", // 上下搭配
    MATERIAL: "materialRecolor", // 面料换色
};

// 姿势裂变模式
export const POSE_FANTASY_MODE = {
    REFERENCEMODE: "ref", // 参考图模式
    FREEMODE: "prompt", // 自由模式
};

// 服装换色类型
export const CLOTH_COLOR_TYPE = {
    CLOTH_RECOLOR: "clothRecolor", // 自由换色
    SIM_RECOLOR: "simRecolor", // 同款换色
};

// 试衣衣服类型
export const TRYON_CLOTH_TYPE = {
    TOP: "top", // 上衣
    BOTTOM: "bottom", // 下装
    DRESS: "dress", // 连体装
};

// 衣服图下的分类
// 衣服示例中会使用
export const CLOTHES_SUBTYPE = {
    SHORT: "clothes_short", // 短袖
    LONG_SLEEVE: "clothes_longSleeve", // 长袖
    PANTS: "clothes_pants", // 裤子
    SKIRT: "clothes_skirt", // 连衣裙
};

// 衣服图生成对应的cloth_type字段
// 算法参数
// 0-上装；1-下装；2-套装；3-裙装
export const CLOTH_TYPE = {
    SHIRT: 0, // 上衣
    PANTS: 1, // 下装
    SUIT: 2, // 套装
    DRESS: 3, // 连体装
};

// 分割算法类型
export const SEGMENT_ALGO_TYPE = {
    AICLOTH_MASK: "aicloth_mask", // 衣服分割 API.maskPredictionAicloth
    AIMODEL_MASK: "aimodel_mask", // 四类分割 API.maskPrediction
    AIMODEL_BODY_MASK: "aimodel_body_mask", // 四类分割 API.maskPrediction
    AIDRESSFORM_MASK: "aidressform_mask", // 人台分割 API.maskPredictionAidressform
    AIGOODS_MASK: "aigoods_mask", // 商品分割 API.maskPredictionGoods
    AISHOES_MASK: "aishoes_mask", // 鞋子分割 API.maskPredictionshoes
    AIGLASSES_MASK: "aishoes_mask", // 眼镜分割 API.maskPredictionshoes
    AISIM_MASK: "aicloth_mask", // 同版型试衣分割 API.maskPredictionAicloth
    SEMANTIC_COLOR_MASK: "semantic_color_mask", // 多语义colorMask分割 API.multiSemanticPrediction
    SEMANTIC_CLOTH_MASK: "semantic_cloth_mask", // 多语义分割，依次取上-》下-》连体
    SEMANTIC_SIMTRYON_MASK: "semantic_cloth_mask", // 多语义分割，依次取上-》下-》连体
};

// 资源类型
export const RESOURCE_TYPE = {
    MODEL: "model", // 真人图
    MODEL_SCENE: "model_scene", // 模特场景图
    TRYON_MODEL: "tryon_model", // tryon 模特图
    POSE_TRYON: "poseFantasy", // 姿势裂变 参考图
    GLASSES_TRYON: "glassesTryon", // 眼镜试戴 参考图
    NECKLACE_TRYON: "necklaceTryon", // 项链试戴 参考图
    SIM_TRYON: "simTryon", // 同版型试衣 参考图
    TRYON_SCENE: "tryon_scene", // tryon场景图
    TRYON_SHOES: "tryon_shoes", // tryon 鞋子图
    VIDEO_MODEL: "video_model", // 视频模特
    IMAGE_TO_VIDEO: "image2Video", // 图生视频描述
    COMMODITY_SCENE: "commodity_scene", // 商品场景图
    COMMODITY_COLOR: "commodity_color", // 商品颜色
    CLOTH_RECOLOR: "cloth_recolor", // 服饰换色
    FUSIONWEAR_MODEL: "fusionWear_model", // 搭配上身
    POSTRYON_PROMPT: "posetryon_prompt", // 姿势裂变提示词
};

// 资源参数
export const RESOURCE_PARAMS = {
    [RESOURCE_TYPE.MODEL]: {
        func: "model", // model
        type: "person", // person
    },
    [RESOURCE_TYPE.TRYON_MODEL]: {
        func: "model", // model
        type: "tryOn", // tryOn
    },
    [RESOURCE_TYPE.POSE_TRYON]: {
        func: "model", // model
        type: "poseFantasy", // poseFantasy
    },
    [RESOURCE_TYPE.GLASSES_TRYON]: {
        func: "model", // model
        type: "glasses", // glassesTryon
    },
    [RESOURCE_TYPE.NECKLACE_TRYON]: {
        func: "model", // model
        type: "necklace", // necklace
    },
    [RESOURCE_TYPE.SIM_TRYON]: {
        func: "model", // model
        type: "simTryon", // simTryon
    },
    [RESOURCE_TYPE.TRYON_SHOES]: {
        func: "model", // model
        type: "shoesTryon", // shoesTryon
    },
    [RESOURCE_TYPE.VIDEO_MODEL]: {
        func: "model", // model
        type: "videoTryOn", // videoTryon
    },
    [RESOURCE_TYPE.COMMODITY_SCENE]: {
        func: "commodity", // commodity
        type: "background", // background
    },
    [RESOURCE_TYPE.MODEL_SCENE]: {
        func: "model", // model
        type: "background", // background
    },
    [RESOURCE_TYPE.TRYON_SCENE]: {
        func: "model", // model
        type: "background", // background
    },
    [RESOURCE_TYPE.IMAGE_TO_VIDEO]: {
        func: "image2Video", // image2Video
        type: "image2VideoPrompt", // image2VideoPrompt
    },
    [RESOURCE_TYPE.POSTRYON_PROMPT]: {
        func: "poseTryonPrompt", // poseTryonPrompt
        type: "poseTryonPrompt", // poseTryonPrompt
    },
};

// 生成模式
export const GENERATE_MODE = {
    STD: "std", // 标准
    HQ: "hq", // 高品质
};

// 模型服务方
export const MODEL_PROVIDER = {
    ARCMUSE: "ArcMuse",
    SOTA: "Sota",
};

// 模特表情
export const MODEL_EXPRESSION = {
    SRC: "src", // 与原图一致
    REF: "ref", // 与参考图一致
};

// 模特发型
export const MODEL_HAIRSTYLE = {
    SRC: "src", // 与原图一致
    REF: "ref", // 与参考图一致
};

export const RELIGHT_MODE = {
    SKIN: "global", // 标准
    PORTRAIT: "face", // 人像
    REFLECTOR: "reflector", // 反光板
    REF: "ref", // 参考图光影
};

//视频生成人物朝向
export const VIDEO_ORIENTATION = {
    SRC: "src", // 与原图一致
    REF: "ref", // 与参考视频一致
};

// 自定义背景模式
export const CUSTOM_BKG_MODE = {
    FREE: "free", // 更加自由
    SIM: "sim", // 非常相似
};

// 模特换背是否选择输出参考图分辨率
export const RESOLUTION_ALIGN = {
    INPUT: "input", // 输入图分辨率
    BKG: "bkg", // 参考图分辨率
};

// 商品图输出比例
export const RESOLUTION_RATIO = {
    CUSTOM: "custom",
    SQUARE: "1:1",
    THREE_FOUR: "3:4",
    FOUR_THREE: "4:3",
    NINE_SIXTEEN: "9:16",
    SIXTEEN_NINE: "16:9",
};

// 商品场景模式选择
export const COMMODITY_SCENE_MODE = {
    // 预置
    PRESET: 0,
    // 相似风格
    SIMILAR_STYLE: 1,
    // 拍同款
    SAME_STYLE: 3,
};

// 浏览结果图位置
export const DISPLAY_TYPE = {
    // 生成中间页面
    GENERATE: "generate",
    // 项目中
    PROJECT: "project",
}

// 服装详情页 comp 字段与模块标题映射
export const SMART_DETAIL_COMP_LABEL_MAP = {
    0: "首屏海报",
    1: "产品卖点",
    2: "痛点解决",
    3: "场景化穿搭",
    4: "产品信息",
    5: "产品细节",
    6: "尺码表",
    7: "购物保障",
}

export const SMART_DETAIL_PLATFORM_LABEL_MAP = {
    taobao: "淘宝",
    tmall: "天猫",
    jd: "京东",
    pdd: "拼多多",
    douyin_shop: "抖音电商",
    vip: "唯品会",
    1688: "1688",
    xiaohongshu: "小红书",
    amazon: "亚马逊",
    tiktok: "Tik Tok",
    shopify: "Shopify",
}

export const SMART_DETAIL_LANG_LABEL_MAP = {
    cn: "中文",
    en: "英文",
    ru: "俄文",
}

// 企业版生图支持功能
export const BATCH_IMAGES_TYPE = {
    TRYON_BATCH: "tryonBatch",
    CHANGE_MODEL_BATCH: "changeModelBatch",
    CHANGE_BKG_BATCH: "changeBkgBatch",
    SIM_RECOLOR_BATCH: "simRecolorBatch",
    IMAGE_FINER_BATCH: "imageFinerBatch",
    WATERMARK_REMOVE_BATCH: "watermarkRemoveBatch",
    FUSIONWEAR_BATCH: "fusionWearBatch",
    SMART_DETAIL_PAGE_BATCH: "smartDetailPageBatch",
    GRASS_PLANT_BATCH: "grassPlantBatch",
    IMAGE_TO_VIDEO_BATCH: "image2VideoBatch",
};

// 企业版抠图优化类型
export const MATTING_OPT_TYPE = {
    RETAIN: "retain", //保留区域
    REPAINT: "repaint", //重绘区域
    REFER: "refer", // 参考区域
};

// 企业版配置详情页列表类型
export const BATCH_RECORD_TYPE = {
    MAINIMG: "mainImg", // 各模块主图
    MATCHIMG: "matchImg", // AI试衣搭配图
    SIM_RECOLOR_INPUT: "simRecolorInputCloth", // 同款换色平铺主图
    SIM_RECOLOR_MATCH: "simRecolorMatchCloth", // 同款换色平铺辅图
};
